export default __webpack_public_path__ + "static/img_articolo_settembre2-968e2ad422b6f7aa3e9bf609d1873c30.jpg";